<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Level Plan</h3>
        <b-row class="justify-content-between" v-if="level_data !== null">
            <b-col cols="auto">
                <span class="text-muted">Level</span>
                <p class="font-weight-600">Level {{ level_data.floor_sort }}</p>
            </b-col>
            <b-col cols="auto" class="align-self-end">
                <el-button type="text" class="py-0" disabled>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 512 512"><path fill="currentColor" d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v242.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-32c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48"/></svg>
                    <span class="pl-2">Download</span>
                </el-button>
            </b-col>
        </b-row>
        <b-img class="border rounded mt-2" src="https://s3-alpha-sig.figma.com/img/34be/9e11/9aba5421fadaf9dfcab910aec51f54bb?Expires=1711929600&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=NQoIVar-yjEtz4HQk2xgHYhwji5UaXYwsaaQnxQcWbEzYxd-DkxvcFsOXlNghav1By~o3m4VxGHVhoRnhelVd~q8y7w4VqiCh4a7tFtjovN2wvMlptLfesUTNHyBxQEP1P-8lz8A9MhKBi8wTPdr24GZNh4C4dBLMaQNxCCFtBl4J4ube~sI0EY7eGyBwGcd05wpo~7RXVHpqiNZA4JXY8JzvygNQFIksJy-P7NPR1ivu4z3gf097dkvZmyaCnC4Aqu9LFHpyMi9tHNyggYzCDNhT5xkZZh3ejbE4MkrrahAHcIB~23qVFnbrAGtTua4x8oulL74hbmVhCNRM~VZzg__" fluid alt="Responsive image" />
    </modal>
</template>
<script>
import { Button } from 'element-ui'
export default {
    props: ['level_plan', 'level_data'],
    components: {
        [Button.name]: Button,
    },
    computed: {
        show: {
            get() {
                return this.level_plan;
            },
            set(value) {
                this.$emit('update:level_plan', value);
            }
        }
    }
}
</script>